export enum PaymentMethod {
  Credit = 1,
  Crypto = 2,
  LoyaltyPoints = 3,
  Bank_Deposit=4
}